import { observer } from 'mobx-react-lite'
import { AiAgentCallLogComponent } from './AiAgentCallLogComponent'
import { useAiAgentCallLog } from './useAiAgentCallLog'

/**
 * Call Log tab body for the merged AI Voice Agent page. Kept as its own
 * component so its data hook only runs while the Call Log tab is mounted.
 */
export const AiAgentCallLogTab = observer(function AiAgentCallLogTab() {
  const hookData = useAiAgentCallLog()
  return <AiAgentCallLogComponent {...hookData} />
})
